import Panorama from './panorama-viewer';

export default {
  init: function (selector) {
    const panoramas = document.querySelectorAll(selector);

    if (panoramas && panoramas.length) {
      [...panoramas].forEach(item => {
        const options = item.getAttribute('data-panorama-options') || '{}';
        const panorama = new Panorama(item, JSON.parse(options));
        panorama.init();
      });
    }
  }
};
